import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import { configure } from 'instantsearch.js/es/widgets'

export default {
  name: 'algolia-addr',

  hitsPerPage: 12,

  componentDidMount () {
    this.locale = document.querySelector('html').getAttribute('lang')

    /// /////////////////////
    // ultra hardcore style
    window.translateLabels = this.translateLabels
    /// /////////////////////

    this.widget = []
    const searchIndex = `${config.algolia.env}_frontUsers`

    this.initCustomSelect()

    this.search = instantsearch({
      indexName: searchIndex,
      searchClient: algoliasearch(
        config.algolia.applicationID,
        config.algolia.apiKeyUsers
      ),
      numberLocale: this.locale,
      routing: true,
    })

    // let searchFilter = `locale:${this.locale}`

    this.widget.push(
      configure({
        hitsPerPage: this.hitsPerPage,
        maxFacetHits: 100,
        facetFilters: ['enabled:true'],
        sortFacetValuesBy: 'alpha',
        // filters: searchFilter,
      })
    )

    this.widget.push(this.filterWidget())

    this.search.addWidgets(this.widget)
    this.search.start()
  },

  filterWidget () {
    // HITS
    const hitsContainer = this.el.querySelector('[js-algolia-addr-hits]')
    const filterContainer = this.el.querySelector('[js-algolia-addr-filter]')
    const alphaContainer = this.el.querySelector('[js-algolia-addr-alphabetic]')
    const moreBtn = this.el.querySelector('[js-algolia-addr-more]')
    const headContainer = this.el.querySelector('[js-algolia-addr-head]')
    const resultContainer = this.el.querySelector('[js-algolia-addr-results]')
    const autocompleteContainer = this.el.querySelector(
      '[js-algolia-addr-autocomplete]'
    )
    this.submitBTN = filterContainer.querySelector('.filter__button button')

    // SELECT + EXPAND
    const refinements = Array.from(
      this.el.querySelectorAll('[js-algolia-addr-refinement]')
    )
    const noResult = this.props.no

    const helperAlpha = (helper, state) => {
      helper
        .setQueryParameter('sortFacetValuesBy', 'alpha')
        .searchForFacetValues('initial', '')
        .then(({ facetHits }) => {
          // facetHits.sortBy
          const select = alphaContainer.querySelector('select')
          const list = alphaContainer.querySelector('.address-list__alphabetic')
          const label = alphaContainer.querySelector('h2').innerHTML

          select.innerHTML = `<option value="">${label}</option>${facetHits
            .map(hits => `<option value="${hits.value}">${hits.value}</option>`)
            .join('')}`
          list.innerHTML = `${facetHits
            .map(hits => `<li data-value="${hits.value}">${hits.value}</li>`)
            .join('')}`

          const items = Array.from(list.querySelectorAll('li'))
          items.forEach((item, index) => {
            item.addEventListener('click', () => {
              const hasActive = list.querySelector('li.is-active')
              if (hasActive) hasActive.classList.remove('is-active')
              select.selectedIndex = index + 1
              item.classList.add('is-active')
              const nFacetFilters = ['enabled:true']

              nFacetFilters.push(`initial:${item.dataset.value}`)
              state.hitsPerPage = 12
              helper
                .setQueryParameter('hitsPerPage', 12)
                .setQueryParameter('facetFilters', nFacetFilters)
                .search()
            })
          })

          select.addEventListener('change', () => {
            const hasActive = list.querySelector('li.is-active')
            if (hasActive) hasActive.classList.remove('is-active')
            const i = select.selectedIndex
            items[i].classList.add('is-active')
            const nFacetFilters = state.facetFilters || []
            nFacetFilters.push(`initial:${select.value}`)
            state.hitsPerPage = 12
            helper
              .setQueryParameter('hitsPerPage', 12)
              .setQueryParameter('facetFilters', nFacetFilters)
              .search()
          })
        })
    }

    const hydrateTarget = (wrap, hits, helper = null) => {
      const ul = wrap.querySelector('ul')
      const select = wrap.querySelector('select')
      const selectMobile = wrap.querySelector('.only-mobile select')
      const refineElt =
        this.props.params[wrap.getAttribute('js-algolia-addr-refinement')] || ''
      ul.innerHTML =
        `<li data-value="" >${wrap.dataset.label}</li>` +
        hits
          .map(
            item =>
              `${
                item.value !== 'undefined' && item.value
                  ? `<li data-value="${item.value}">` +
                    this.translateLabels(item.value) +
                    `</li>`
                  : ''
              }`
          )
          .join('')
      select.innerHTML =
        `<option value="" ${refineElt === '' ? 'selected' : ''}>${
          wrap.dataset.label
        }</option>` +
        hits
          .map(
            item =>
              `${
                item.value !== 'undefined' && item.value
                  ? `<option value="${item.value}" ${
                    refineElt === item.value ? 'selected' : ''
                  }>` +
                    this.translateLabels(item.value) +
                    `</option>`
                  : ''
              }`
          )
          .join('')

      const li = Array.from(wrap.querySelectorAll('li'))
      const label = wrap.querySelector('button span')

      li.forEach((item, index) => {
        item.addEventListener('click', () => {
          label.innerHTML = item.innerHTML
          select.selectedIndex = index
          wrap.querySelector('.custom-select').classList.remove('is-expanded')
          const nextElt = wrap.nextElementSibling

          // IF COUNTRY HYDRATE
          if (
            wrap.getAttribute('js-algolia-addr-refinement') ===
            'foreignAddress.country'
          ) {
            // IF FRANCE SELECTED
            if (select.value === 'France') {
              // alert('coucou ' + item.dataset.value)
              helper.setQueryParameter('facetFilters', [
                'enabled:true',
                'foreignAddress.country:',
              ])
              helper
                .searchForFacetValues('shortPostalCode', '', {
                  filters: `country:${item.dataset.value}`,
                })
                .then(({ facetHits }) => {
                  nextElt.classList.remove('disabled')
                  nextElt.setAttribute(
                    'js-algolia-addr-refinement',
                    'shortPostalCode'
                  )
                  nextElt.querySelector('button').removeAttribute('disabled')
                  // commenté car hydrate en fonction des résultats déjà diplayed sur la page
                  // hydrateTarget(nextElt, facetHits)
                })
            } else {
              nextElt.classList.add('disabled')
              nextElt.querySelector('button').setAttribute('disabled', 'true')
              this.submitBTN.parentNode.classList.remove('disabled')
              this.submitBTN.removeAttribute('disabled')
            }
          } else {
            // reactivate search btn if country == France and shortcode is filled
            if (
              wrap.getAttribute('js-algolia-addr-refinement') ===
                'shortPostalCode' &&
              wrap.querySelector('select').value !== ''
            ) {
              this.submitBTN.parentNode.classList.remove('disabled')
              this.submitBTN.removeAttribute('disabled')
            }
          }
        })
      })

      // condition pour selects mobile :
      if (
        wrap.getAttribute('js-algolia-addr-refinement') ===
        'foreignAddress.country'
      ) {
        selectMobile.addEventListener('change', () => {
          const nextElt = wrap.nextElementSibling
          if (selectMobile.value === 'France') {
            helper
              .searchForFacetValues('shortPostalCode', '', {
                filters: `country:${selectMobile.value}`,
              })
              .then(({ facetHits }) => {
                nextElt.classList.remove('disabled')
                nextElt.setAttribute(
                  'js-algolia-addr-refinement',
                  'shortPostalCode'
                )
                // hydrateTarget(wrap.nextElementSibling, facetHits)
              })
          } else {
            nextElt.querySelector(
              '.only-mobile select'
            ).value = selectMobile.querySelector('option').value
            nextElt.classList.add('disabled')
          }
        })
      } /* else { // ici ça a été commenté il y a longtemps je ne sais plus pourquoi..
        if (
          wrap.nextElementSibling.getAttribute('js-algolia-addr-refinement') !==
          'foreignAddress.country'
        ) {
          const nextElt = wrap.nextElementSibling
          nextElt.classList.add('disabled')
          nextElt.querySelector('button').setAttribute('disabled', 'true')
        }
      } */

      /* if ( // A PRIORI NE PASSE JAMAIS DANS CETTE CONDITION CAR celect.value == '' A L'INIT
        wrap.getAttribute('js-algolia-addr-refinement') ===
          'foreignAddress.country' &&
        select.value === 'France'
      ) {
        alert(select.value)
        select.addEventListener('change', () => {
          helper
            .searchForFacetValues('shortPostalCode', '', {
              filters: `country:${select.value}`,
            })
            .then(({ facetHits }) => {
              const nextElt = wrap.nextElementSibling
              nextElt.classList.remove('disabled')
              nextElt.setAttribute(
                'js-algolia-addr-refinement',
                'shortPostalCode'
              )
              nextElt.querySelector('button').removeAttribute('disabled')
              hydrateTarget(wrap.nextElementSibling, facetHits)
            })
        })
      } */
    }

    const elParams = this.props.params
    const locale = this.props.params.locale
    const that = this

    const widget = {
      init (opts) {
        const { helper, state } = opts

        const input = filterContainer.querySelector('input[type="text"]')

        // FILTERS INIT CHANGE ----
        for (const wrap of refinements) {
          helper
            .searchForFacetValues(
              wrap.getAttribute('js-algolia-addr-refinement'),
              ''
            )
            .then(({ facetHits }) => {
              hydrateTarget(wrap, facetHits, helper)
            })
        }

        input.addEventListener('input', () => {
          if (input.value !== '') {
            autocompleteContainer.classList.remove('is-hidden')
            helper.setQuery('') // otherwise algogo search facet matching the input value +  the previous query value
            const titleValues = helper
              .searchForFacetValues('activityType.title', input.value)
              .then(({ facetHits }) => {
                const data = facetHits.map(item => item.value)

                return data
              })
            const nameValues = helper
              .searchForFacetValues('name', input.value)
              .then(({ facetHits }) => {
                const data = facetHits.map(item => item.value)
                return data
              })
            Promise.all([nameValues, titleValues]).then(data => {
              const values = data[0].concat(data[1])
              autocompleteContainer.innerHTML = values
                .map(val => `<li data-value="${val}">${val}</li>`)
                .join('')
              const list = autocompleteContainer.querySelectorAll('li')
              for (const li of list) {
                li.addEventListener('click', () => {
                  input.value = li.dataset.value
                  autocompleteContainer.classList.add('is-hidden')
                })
              }
            })
          } else {
            autocompleteContainer.innerHTML = ``
            autocompleteContainer.classList.add('is-hidden')
          }
        })

        // REFINE BASE
        // helper.setQueryParameter('facetFilters', filters)

        helperAlpha(helper, state)

        // SUBMOT --->
        that.submitBTN.addEventListener('click', () => {
          const selectWrap = Array.from(
            filterContainer.querySelectorAll('[js-algolia-addr-refinement]')
          )
          const alphaSelect = alphaContainer.querySelector('select')

          const filters = selectWrap.reduce(
            (acc, item) => {
              const select = item.querySelector('select')
              const type = item.getAttribute('js-algolia-addr-refinement')

              if (select.value !== '') acc.push(`${type}:${select.value}`)
              return acc
            },
            ['enabled:true']
          )

          // console.log(filters)

          let isFrance = false

          filters.forEach((f, i) => {
            // if france we search on country, not foreignAddress.country
            if (f === 'foreignAddress.country:France') {
              isFrance = true
              filters[i] = 'country:France'
            }
          })

          // delete shortpostal code if other country than france
          if (
            !isFrance &&
            filters[filters.length - 1].indexOf('shortPostalCode') > -1
          ) {
            filters.pop()
          }

          alphaSelect.value = ''
          if (alphaContainer.querySelector('li.is-active')) {
            alphaContainer
              .querySelector('li.is-active')
              .classList.remove('is-active')
          }

          if (filters.length > 1 || input.value !== '') {
            if (headContainer) headContainer.classList.add('hidden')
            alphaContainer.classList.add('hidden')
          } else {
            alphaContainer.classList.remove('hidden')
            if (headContainer) headContainer.classList.remove('hidden')
          }

          state.hitsPerPage = 12
          helper.setQueryParameter('facetFilters', filters)
          helper.setQueryParameter('hitsPerPage', 12)
          helper.setQuery(input.value)
          helper.search(state)
        })

        // CLICK ADD MORE
        moreBtn.addEventListener('click', () => {
          state.hitsPerPage = state.hitsPerPage + 12
          helper
            .setQueryParameter('hitsPerPage', state.hitsPerPage)
            .search(state)
        })

        // INIT if props params
        const filters = refinements.reduce(
          (acc, wrap) => {
            const type = wrap.getAttribute('js-algolia-addr-refinement')
            if (elParams[type] !== '') {
              acc.push(`${type}:${wrap.querySelector('select').value}`)
            }
            return acc
          },
          ['enabled:true']
        )

        if (filters.length > 1) {
          helper.setQueryParameter('facetFilters', filters)
        }
        if (elParams.query !== '') helper.setQuery(input.value)
        if (elParams.query !== '' || filters.length > 1) {
          if (headContainer) headContainer.classList.add('hidden')
          // alphaContainer.classList.add('hidden')

          helper.setQueryParameter('facetFilters', filters)
          helper.setQuery(input.value)
          helper.search()
        }
      },
      render (opts) {
        const { results } = opts

        if (results.nbHits <= results.hitsPerPage) {
          moreBtn.classList.add('is-hidden')
        } else {
          moreBtn.classList.remove('is-hidden')
        }

        if (results.nbHits > 0) {
          resultContainer.innerHTML =
            `${results.nbHits}` + (locale === 'en' ? ` results` : ` résultats`)
          hitsContainer.innerHTML = results.hits
            .map(
              item =>
                `<li class="col-12 md-col-6 lg-col-5">
                  <a href="${
  locale === 'en'
    ? item.frontUrl.replace('/membre/', '/en/membre/')
    : item.frontUrl
}" rel="nofollow" class="address-list__item result flex items-center">
                    <div class="picture result__picture">
                      ${
  item.webLogo && item.webLogo !== ''
    ? `<img src="${item.webLogo}" alt="${item.name}" />`
    : ''
}
                    </div>
                    <div class="result__content">
                      <h3 class="uppon-title uppon-title--medium uppon-title--blue uppercase">${
  item.name
}</h3>
                      ${
  item.userType !== null
    ? locale === 'en'
      ? `<p class="result__type">${window.translateLabels(
        item.userType
      )}</p>`
      : `<p class="result__type">${item.userType}</p>`
    : ''
}
                      ${
  item.website && item.website !== ''
    ? `<p class="result__link">${item.website}</p>`
    : ''
}
                    </div>
                  </a>
                </li>`
            )
            .join('')
        } else {
          alphaContainer.classList.add('hidden')
          hitsContainer.innerHTML = ''
          resultContainer.innerHTML = `${noResult}`
        }
      },
      getWidgetState (uiState) {
        return uiState
      },
    }

    return widget
  },

  // EXPAND CLASS
  initCustomSelect () {
    const customSelects = Array.from(
      this.el.querySelectorAll('[js-algolia-select]')
    )

    document.addEventListener('click', e => {
      const isContain = customSelects.reduce((acc, select) => {
        if (select.contains(e.target)) acc = true
        return acc
      }, false)

      if (!isContain) {
        this.closeExpand()
      }
    })

    for (const custom of customSelects) {
      const button = custom.querySelector('button')

      button.addEventListener('click', () => {
        const child = custom.querySelector('.custom-select')
        if (child.classList.contains('is-expanded')) {
          child.classList.remove('is-expanded')
          button.setAttribute('aria-expanded', false)
        } else {
          this.closeExpand()
          child.classList.add('is-expanded')
          button.setAttribute('aria-expanded', true)
        }
      })
    }
  },

  closeExpand () {
    const hasExpanded = this.el.querySelector('.custom-select.is-expanded')
    if (hasExpanded) {
      hasExpanded.querySelector('button').setAttribute('aria-expanded', false)
      hasExpanded.classList.remove('is-expanded')
    }
  },

  translateLabels (value) {
    if (this.props.params.locale === 'en') {
      switch (value) {
        case 'Comité Aéro-PME':
          return 'AERO-SME Committee'
        case 'Constructeurs et Systémiers':
          return 'Prime contractors & system suppliers'
        case 'GEAD':
        case 'GEADS':
          return 'Aerospace and Defence Equipment Group'
        case 'Société de Service':
          return 'Service Company'
        default:
          return value
      }
    } else {
      return value
    }
  },
}
